/* Landing Upstart drive-to-store — formulaire d'essai : validation de la date
   (boutique fermée le dimanche). Extrait du monolithe (factorisation ADR-007).
   Sélecteur racine adapté en .uds[data-section-id] (asset statique, hors Liquid).
   Comportement inchangé. */
(function() {
  var root = document.querySelector('.uds[data-section-id]');
  if (!root) return;

  var dateInput = root.querySelector('[data-uds-test-date]');
  var dateError = root.querySelector('[data-uds-date-error]');
  var testForm = dateInput ? dateInput.closest('form') : null;
  var sundayMessage = 'La boutique est fermée le dimanche. Choisissez une date du lundi au samedi.';

  var validateTestDate = function() {
    if (!dateInput) return true;

    if (!dateInput.value) {
      dateInput.setCustomValidity('');
      dateInput.classList.remove('is-invalid');
      dateInput.removeAttribute('aria-invalid');
      if (dateError) dateError.hidden = true;
      return true;
    }

    var selectedDate = new Date(dateInput.value + 'T12:00:00');
    var isSunday = !Number.isNaN(selectedDate.getTime()) && selectedDate.getDay() === 0;

    dateInput.setCustomValidity(isSunday ? sundayMessage : '');
    dateInput.classList.toggle('is-invalid', isSunday);

    if (isSunday) {
      dateInput.setAttribute('aria-invalid', 'true');
    } else {
      dateInput.removeAttribute('aria-invalid');
    }

    if (dateError) dateError.hidden = !isSunday;
    return !isSunday;
  };

  if (dateInput) {
    dateInput.addEventListener('change', validateTestDate);
    dateInput.addEventListener('input', validateTestDate);
  }

  if (testForm) {
    testForm.addEventListener('submit', function(event) {
      if (validateTestDate()) return;
      event.preventDefault();
      dateInput.reportValidity();
      dateInput.focus();
    });
  }
})();
